<template>
    <header class="topbar">
        <div class="topbar__inner">
            <a href="/allassesments" class="brand">
                <span class="brand__logo">&lt;/&gt;</span>
                Entrance Exam
            </a>
            <nav class="topbar__nav">
                <a href="/allassesments" class="topbar__link" :class="{'is-active': activeTab()=='all-exams-page'}">Exams</a>
                <a href="/addexam" class="topbar__link" :class="{'is-active': activeTab()=='add-exam-page'}">＋ New Exam</a>
                <a href="/allquestions" class="topbar__link" :class="{'is-active': activeTab()=='all-questions-page'}">Questions</a>
                <a href="/addquestion" class="topbar__link" :class="{'is-active': activeTab()=='add-question-page'}">＋ New Question</a>
            </nav>
            <div class="topbar__user">
                <span class="topbar__hello">Hello, <strong>{{$store.state.auth.name}}</strong></span>
                <button class="btn btn--ghost btn--sm" @click="onLogout">Logout</button>
            </div>
        </div>
    </header>
</template>
<script>
import router from '@/router';
import Vue from 'vue';

export default {
    name: 'ExaminerNavBar',
    methods: {
        onLogout() {
             try{
                    this.$store.dispatch('logout');
                    Vue.$toast.success('Logged Out Successfully')
                    this.$router.push({ name :'login-page'})
                } catch(error){
                    Vue.$toast.error(error.message);
                }
        },
        activeTab() {
            if (    router.currentRoute.name == 'all-exams-page'
                        || router.currentRoute.name == 'answer-page'
                            || router.currentRoute.name == 'user-submittion-page')
            return 'all-exams-page';
            else return router.currentRoute.name;
        }
    }
}
</script>
